import axios from 'axios';
import axiosRetry from 'axios-retry';
import {REACT_APP_API_SERVER, TOKEN_KEY} from '../constants';

// Define base API url (based on the environment)
export const DEFAULT_API_URL = REACT_APP_API_SERVER;

// If token exist - Build auth header (Bearer auth)
export const getAuthHeader = () => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    return `Bearer ${token}`;
  }
  return '';
};

// Creating axios request instance
const apiWithRetry = axios.create({
  baseURL: DEFAULT_API_URL,
  headers: {
    'ngrok-skip-browser-warning': '1'
  },
  timeout: 20000,
});

// Attach a request interceptor to automatically add the Authorization header
apiWithRetry.interceptors.request.use((config) => {
  const authHeader = getAuthHeader();
  if (authHeader) {
    config.headers.Authorization = authHeader;
  }
  return config;
});

// Add retry logic: 3 retries, exponential backoff starting at 5 seconds (5000ms)
axiosRetry(apiWithRetry, {
  retries: 3,
  retryDelay: (retryCount) => 5000 * Math.pow(2, retryCount - 1) // 5s, 10s, 20s
});

export default apiWithRetry;